export default [
  {
    path: '/404',
    name: 'Error_404',
    component: () => import('@/components/error-page/404'),
  },
];
